import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const VideoIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 18 14"
  >
    <path
      fillRule="evenodd"
      d="M16.92 2.879a.75.75 0 0 1 .33.621v7a.75.75 0 0 1-1.029.696l-5-2a.75.75 0 0 1 .557-1.392l3.972 1.588V4.608l-3.972 1.588a.75.75 0 0 1-.556-1.392l5-2a.75.75 0 0 1 .698.075"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M2.5 2.25a.25.25 0 0 0-.25.25v9c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-9a.25.25 0 0 0-.25-.25zM.75 2.5c0-.966.784-1.75 1.75-1.75h8c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75h-8A1.75 1.75 0 0 1 .75 11.5z"
      clipRule="evenodd"
    />
  </svg>
);
VideoIcon.displayName = 'VideoIcon';
export default VideoIcon;
